(function () {
  var STORAGE_KEY = 'contact_gclid';
  var FIELD_NAME = 'contact[gclid]';

  function normalizeConsent(value) {
    if (value === true) return true;
    if (value === false || value == null) return false;

    var normalized = String(value).toLowerCase();
    return normalized === 'granted' || normalized === 'yes' || normalized === 'true' || normalized === '1';
  }

  function getCustomerPrivacyApi() {
    if (typeof window === 'undefined' || !window.Shopify) return null;
    return window.Shopify.customerPrivacy || null;
  }

  function hasMarketingConsent() {
    var privacyApi = getCustomerPrivacyApi();
    if (!privacyApi) return false;

    try {
      if (typeof privacyApi.marketingAllowed === 'function') {
        return normalizeConsent(privacyApi.marketingAllowed());
      }

      if (typeof privacyApi.currentVisitorConsent === 'function') {
        var consent = privacyApi.currentVisitorConsent();
        if (!consent || !('marketing' in consent)) return false;
        return normalizeConsent(consent.marketing);
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function getUrlGclid() {
    try {
      var params = new URLSearchParams(window.location.search);
      var gclid = params.get('gclid');

      if (!gclid) return '';

      return String(gclid).trim().slice(0, 255);
    } catch (error) {
      return '';
    }
  }

  function storeGclid(gclid) {
    if (!gclid) return;

    try {
      window.sessionStorage.setItem(STORAGE_KEY, gclid);
    } catch (error) {
      // Ignore storage failures in private mode/restricted browsers.
    }
  }

  function getStoredGclid() {
    try {
      var value = window.sessionStorage.getItem(STORAGE_KEY) || '';
      return value.trim();
    } catch (error) {
      return '';
    }
  }

  function appendGclidField(form) {
    if (!form || !hasMarketingConsent()) return;

    var gclid = getStoredGclid();
    if (!gclid) {
      gclid = getUrlGclid();
      if (gclid) {
        storeGclid(gclid);
      }
    }

    if (!gclid) return;

    var existing = form.querySelector('input[name="' + FIELD_NAME + '"]');
    if (existing) {
      existing.value = gclid;
      return;
    }

    var field = document.createElement('input');
    field.type = 'hidden';
    field.name = FIELD_NAME;
    field.value = gclid;
    form.appendChild(field);
  }

  function bindContactForms() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function () {
        appendGclidField(form);
      });
    });
  }

  function captureGclidFromUrlIfConsented() {
    var gclid = getUrlGclid();
    if (!gclid) return;
    if (!hasMarketingConsent()) return;

    storeGclid(gclid);
  }

  function init() {
    captureGclidFromUrlIfConsented();
    bindContactForms();

    // Consent can be granted after initial page load via banner interaction.
    document.addEventListener('visitorConsentCollected', function () {
      captureGclidFromUrlIfConsented();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
